<template>
	<div v-if="!selectedRegion">
		<div class="currency-modal-container">
		</div>
		<div class="currency-modal">
			<div class="currency-modal-content">
				<h1 v-text="$__('site.select.currency.title')"></h1>
				<div class="currency d-flex">
					<p v-text="$__('site.select.currency.message')"></p>
					<div class="buttons">
						<div v-for="region in regions">
							<template v-if="region.title === 'Europe'">
								<a :href="region.url" :title="region.title" @click.prevent="saveRegion(region.id)" class="left">€</a>
							</template>
							<template v-if="region.title !== 'Europe'">
								<a :href="region.url" :title="region.title" @click.prevent="saveRegion(region.id)" class="right">$</a>
							</template>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.currency-modal-container {
	display: block;
	position: fixed; /* Stay in place */
	z-index: 999; /* Sit on top */
	left: 0;
	top: 0;
	bottom: 0;
	right: 0;
	width: 100%; /* Full width */
	height: 100%; /* Full height */
	overflow: hidden; /* Enable scroll if needed */
	background-color: rgb(0, 0, 0); /* Fallback color */
	opacity: 0.85;
}

.currency-modal-container {

}

.currency-modal {
	display: block;
	position: fixed;
	top: 50%;
	left: 50%;
	margin-top: -338px;
	margin-left: -250px;
	width: 540px;
	height: 540px;
	padding: 20px 20px 20px 30px;
	text-align: center;
	background-color: black;
	background-repeat: no-repeat;
	background-size: 540px 657px;
	background-image: url('/images/currency_selector_bg.png');
	color: black;
	border-radius: 25px;
	opacity: 1;
	z-index: 1000;
}


.currency-modal-content {
	right: 40%;
}

.currency-modal-content h1 {
	margin-top: 10px;
	line-height: 1;
}

.currency-modal-content h1, .currency-modal-content p {
	text-align: left;
	color: white;
}


div.currency {
	display: flex;
	flex-direction: column;
	align-items: center;
}

div.currency p {
	font-size: 28px;
	width: 90%;
	padding-bottom: 0;
}

div.buttons{
	flex: 1;
	display: flex;
	flex-direction: row;
	width: 100%;
	justify-content: center;
}

div.currency a {
	flex: 1;
	padding: 15px 20px 15px 20px;
	font-size: 70px;
	text-decoration: none;
	border-radius: 5px;
	margin-top: 30px;
	color: white;
	background-color: #e6007e;
	border: 1px solid #e6007e;
}

div.currency a.left {
	margin-right: 30px;
}
div.currency a.right {
	margin-left: 30px;
}


div.currency a:hover {
	text-decoration: none;
	color: #e6007e;
	background-color: white;
}


@media only screen and (max-width: 550px) {
	.currency-modal {
		margin-top: -218px;
		margin-left: -175px;
		width: 350px;
		height: 400px;
		background-color: white;
		background-size: 350px 450px;
	}
	.currency-modal-content h1 {
		font-size: 61px;
	}

	div.currency p {
		font-size: 18px;
	}
	div.currency a {
		padding: 10px 15px 10px 15px;
		font-size: 45px;
	}

	div.currency a.left {
		margin-right: 15px;
	}
	div.currency a.right {
		margin-left: 15px;
	}
}


</style>

<script>


import ClickOutside from "vue-click-outside";

export default {
	name: "CurrencySelector",
	data: function () {
		return {
			selectedRegion: false,
		}
	},
	props: {
		regions: Array | Object
	},
	computed: {},
	methods: {
		saveRegion(region, e) {

			document.cookie = `lupit_selected_region=${region}; path=/; max-age=${7 * 24 * 60 * 60}; SameSite=None; Secure`;

			axios.post(`/api/region`, {region: region})
				.then(response => {
					if (response.data.error === false) {
						localStorage.setItem('lupit_selected_region', region);
						location.reload()
					}
				})
				.catch(function (error) {
					// error
				})
		},
	},
	mounted() {
		this.selectedRegion = localStorage.getItem('lupit_selected_region');
	},
	directives: {
		ClickOutside
	}
}
</script>
